import { APICallV3Get } from 'reactApp/api/APICall';

export class RateLimitAPICall extends APICallV3Get {
    _method = 'ratelim';
}
